import moment from 'moment'
import { helpers } from 'vuelidate/lib/validators'

export const messages = {
  required: () => 'Required',
  maxLength: ({ $params }) => `Must be maximum of ${$params.maxLength.max} characters.`,
  minLength: ({ $params }) => `Must be at least ${$params.minLength.min} characters.`,
  integer: () => 'Must be numeric value',
  minValue: ({ $params }) => `The minimum value is ${$params.minValue.min}`,
  maxValue: ({ $params }) => `The maximum value is ${$params.maxValue.max}`,
  isDateBeforeMaxDate: ({ $params }) => $params.isDateBeforeMaxDate.value.message,
  isDateValid: () => 'Invalid date',
  email: () => 'Invalid email',
  sameAs: ({ $params }) => `Doesn't match ${$params.sameAs.eq}`,
  ipAddress: () => 'Invalid IP address'
}

export const isDateValid = function(date) {
  return helpers.withParams({ type: 'isDateValid', value: date }, () => {
    if (!date) return true
    return !!moment(date, this.settings.date_format, true).isValid()
  })()
}

export const isDateBeforeMaxDate = function(date, maxDate, message = `Must be before (${maxDate})`) {
  return helpers.withParams({ type: 'isDateBeforeMaxDate', value: { maxDate, message } }, () => {
    if (!date) return true
    return moment(date, this.settings.date_format).isBefore(moment(maxDate, this.settings.date_format))
  })()
}

export const validationPass = function() {
  this.$v.$touch()

  if (this.activeTab === 'basic' && this.$v.$invalid) return false
  if (this.activeTab === 'metaData' && this.$refs.metaData.hasFieldErrors()) return false
  if (!this.metaDataFields && !this.$v.$invalid) return true
  if (this.activeTab === 'basic' && !this.$refs.metaData && !this.$v.$invalid) {
    const metaDataFields = Object.entries(this.metaDataFields).reduce((acc, [, fields]) => {
      acc.push(...fields)
      return acc
    }, [])
    const hasRequiredFields = metaDataFields.some(field => field.is_required)
    if (hasRequiredFields) {
      this.activeTab = 'metaData'
      this.$nextTick(() => {
        this.$refs.metaData.triggerValidation()
      })
      return false
    }
    return true
  }
  if (this.activeTab === 'metaData' && !this.$refs.metaData.hasFieldErrors() && this.$v.$invalid) {
    this.activeTab = 'basic'
    return false
  }
  if (this.activeTab === 'basic' && !this.$v.$invalid && this.$refs.metaData.hasFieldErrors()) {
    this.activeTab = 'metaData'
    return false
  }
  return true
}
